/* @flow */

module.exports = {
  "LOCALE": {
    "ISO": {
      "639-1": "sv",
      "3166-1": "SE",
      "IETF": "sv-SE",
    },
    "CURRENCY": "SEK",
    "CURRENCY_SHORT": "kr",
    "POINTS": "poäng",
    "BASIC_POINTS": "Nivåpoäng",
    "EXTRA_POINTS": "Bonuspoäng",
  },
  "META": {
    "GOOGLE_SITE_OWNER": "JE5RJH9mE7LLsEhBFrF7e0T3poF_BesW7P3wibE8XwA",
    "HELPDESK_LINK": "https://helpdesk.crossroads.se/?s=aad25d0d4497afed7cbd8b5ebe79f19c",
  },
  "SKIP_TO_CONTENT": "Gå till innehåll",
  "LOGO": {
    "ALT": "SAS",
    "TITLE": "Gå till startsidan",
  },
  "COOKIE_CONSENT": {
    "ALL": "Tillåt alla",
    "SELECTED": "Tillåt urval",
    "NECESSARY": "Tillåt nödvändiga",
  },
  "COOKIE_OPTIONS": {
    "NECESSARY": "Nödvändiga",
    "STATISTICAL": "Statistiska",
    "MARKETING": "Marknadsföring",
  },
  "LANGUAGE_SWITCHER": {
    "CLOSE": "Stäng språkval",
  },
  "CLOSE_SYSTEM_MESSAGE": "Stäng meddelande",
  "CURRENCY_SHORT": {
    "NOK": "kr",
    "DKK": "kr",
    "SEK": "kr",
    "EUR": "€",
  },
  "APP": {
    "COUNTRY_MODAL": "Du har loggat in med ett EuroBonus-konto registrerat i %country. Vill du byta land?",
  },
  "HOMEVIEW": {
    "POPULAR_CATEGORIES": "Utforska populära kategorier",
    "SEE_MORE_POPULAR_CATEGORIES": "Till alla kategorier",
    "POPULAR_PRODUCTS": "Våra bästsäljare",
    "SEE_MORE_POPULAR_PRODUCTS": "Se fler bästsäljare",
    "RECENTLY_VIEWED_PRODUCTS": "Senast besökta",
  },
  "ALL_PRODUCTS": {
    "TITLE": "Produkter",
    "TITLE_PREFIX_LOADING": "Laddar alla",
  },
  "PRODUCTLIST_HERO": {
    "PRODUCTS_FROM": "Produkter från",
    "TITLE_PREFIX_EMPTY": "Inga produkter att visa",
    "TITLE_PREFIX_SINGULAR": "Visar 1 produkt i <span>%title</span>",
    "TITLE_PREFIX_PLURAL": "Visar %itemsCount produkter i <span>%title</span>",
    "IN_PRICERANGE": "i prisintervallet <span>%points poäng</span>",
    "POINTS": "poäng",
  },
  "CAROUSEL": {
    "ITEM_LABEL": "Artikel %current av %total",
    "CONTROLS": {
      "LABEL": "Navigation för karusell",
      "PREV_ITEM_GROUP_LABEL": "Föregående artikelgrupp",
      "NEXT_ITEM_GROUP_LABEL": "Nästa artikelgrupp",
      "GO_TO_ITEM_GROUP_LABEL": "Gå till artikelgrupp %number",
      "PLAY_LABEL": "Starta automatisk uppspelning",
      "PAUSE_LABEL": "Pausa automatisk uppspelning",
    },
  },
  "ADVENT_CALENDAR": {
    "TEXT": "Julkalender",
    "LINK": "/advent-calendar",
    // "LINK": "/advent-calendar?testDate=2020-12-1&password=sasAwarditTest1701",
    "DOOR_TITLE": "Lucka %day",
    "VIEW_ALL_PRODUCTS": "Visa alla produkter i dagens lucka",
    "BACK": "Tillbaka till julkalendern",
    "SAVE_PERCENTAGE": "Spara upp till %percentage%",
    "CATEGORY_URL": "advent-calendar",
    "OPEN_DOOR": "Öppna lucka",
    "OPEN_DOOR_ALT": "Öppna lucka",
    "CLOSED_DOOR_ALT": "Stängd lucka",
    "CALENDAR_CLOSED": "Julkalendern är stängd",
    "TOTAL_COUNT_EMPTY": "Inga produkter att visa",
    "TOTAL_COUNT_SINGULAR": "Visar 1 produkt",
    "TOTAL_COUNT_PLURAL": "Visar %totalCount produkter",
    "LANDING": {
      "HEADING": "EUROBONUS SHOP JULKALENDER",
      "TEXT": "Spännande erbjudanden varje dag fram till julafton, startar första december.",
    },
    "FORM": {
      "SUBSCRIBE_NOW": "Missa inte första luckan – anmäl dig nu!",
      "EMAIL": "E-mail",
      "SUBMIT": "Bekräfta anmälan",
    },
  },
  "ACCOUNT": {
    "MY_ACCOUNT": "Mitt konto",
    "LOGOUT": "Logga ut",
    "ACCOUNT_INFORMATION": "Kontoinformation",
    "OWNER": "Ägare",
    "MEMBERSHIP": "Medlemsskap",
    "MEMBERSHIP_LEVEL": "Medlemsnivå",
    "MEMBER_NUMBER": "EB-nr",
    "LAST_REGISTERED_POINTS": "Senast registrerade poäng",
    "POINTS_READ_MORE": "Du kan läsa mer om dina poäng på",
    "POINTS_READ_MORE_LINK": "https://www.sas.se/",
    "SHIPPING_ADDRESS": "Leveransadress",
    "ELAPSED_POINTS": "Utgående poäng",
    "ELAPSING_POINTS_INFO": "Du har %points poäng som går ut den %date (%dateRelative)",
    "EDIT_INFO_TEXT": "Du ändrar dina uppgifter på sas.se",
    "EDIT_INFO": "Ändra mina uppgifter",
    "WISHLIST": "Önskelista",
    "EMAIL": "E-mail",
    "BALANCE": "Saldo",
    "TOTAL_POINTS": "Totalt",
    "DATE": "Datum",
    "SEE_ALL": "Se alla",
    "BUY_AND_TRANSFER_POINTS": "Köp eller ge bort poäng",
    "EDIT": "Ändra",
    "EDIT_ADDRESS": "Ändra adress",
    "EDIT_COUNTRY": "Ändra land",
    "EDIT_URL": "https://www.sas.se/profile/#/profile?userAction=Settings",
    "READ_MORE": "Läs mer",
    "TIER": {
      "B": "Medlem",
      "S": "Silver",
      "G": "Guld",
      "D": "Diamant",
      "P": "Pandion",
    },
  },
  "COUNTRY": {
    "HEADING": "Välj leveransland",
    "DELIVER_TO": "Leverera till",
  },
  "ORDER_HISTORY": {
    "PAGINATION": "Sida %current / %total",
  },
  "PURCHASE_POINTS": {
    "CUSTOMER_NOT_ELIGABLE": "Ditt konto uppfyller inte villkoren för att kunna köpa och överföra poäng ännu. För att kunna köpa, överföra och ta emot Bonuspoäng behöver du ha varit medlem i minst ett år, och ha minst en registrerad aktivitet på ditt EuroBonus-konto. Dessutom behöver du ha minst 1 000 poäng tillgängliga på ditt konto. Om du behöver poäng för att nå nästa medlemsnivå eller behålla din nuvarande kan du köpa Nivåpoäng. Detta kan användas om du saknar en specifik mängd Nivåpoäng.",
    "STEP_NAMES": {
      "find-recipient": "Mottagare",
      "point-select": "Belopp",
      "payment-split": "Betalningsfördelning",
      "payment": "Betalning",
    },
    "TITLE": "Köp & ge poäng",
    "DESCRIPTION": "Här kan du transferera Bonuspoäng, köpa Bonuspoäng och om du saknar ett begränsat antal poäng till nästa nivå kan du köpa Nivåpoäng.",
    "BALANCE": "Ditt poängsaldo är %balance",
    "BASIC_POINTS_EARNED": "Du har hittills tjänat %earned Nivåpoäng under innevarande kvalificeringsperiod.",
    "BUY_FOR_FRIEND": "Köp till en vän",
    "TRANSFER_TO_FRIEND": "Transferera till en vän",
    "BUY_FOR_SELF": "Köp till dig själv",
    "EDIT": "Ändra",
    "SAVE_AND_PROCEED": "Spara och fortsätt",
    "CHOOSE": "Välj",
    "CALCULATING": "…",
    "HOW_MANY_POINTS_PURCHASE": "Hur många poäng vill du köpa?",
    "HOW_MANY_POINTS_TRANSFER": "Hur många poäng vill du transferera?",
    "YOU_WILL_RECEIVE": "Du köper",
    "SELECT_POINTS_TOOLTIP_TITLE": "Välj poängsumma",
    "SELECT_POINTS_TOOLTIP_DESCRIPTION": "Dra i reglaget för att välja hur många poäng du vill köpa eller överföra.",
    "PAYMENT_TOOLTIP_TITLE": "Hur vill du betala transaktionskostnaden?",
    "PAYMENT_TOOLTIP_DESCRIPTION": "Dra i reglaget för att justera hur du vill betala transaktionskostaden. Vill du endast använda poäng drar du reglaget helt till höger och vill du istället betala med endst pengar drar du den helt åt vänster.",
    "RECIPIENT": "Mottagare",
    "WHO_IS_RECIPIENT": "Vem är mottagaren?",
    "CONFIRMATION": "Betalning",
    "CONFIRMATION_SUBTITLE": "Fördela betalningen mellan Bonuspoäng och kortbetalning.",
    "FAQ": {
      "TITLE": "Vanliga frågor",
      "1": {
        "Q": "Poängen jag vill transferera till någon annan håller på att gå ut. Hur länge blir de giltiga på det andra kontot?",
        "A": "När Bonuspoäng transfereras blir de giltiga 5 år från överföringsdatumet. Men ångrar du köpet och beställningen går tilbaka kommer de poäng som förfallit förfalla. Du får alltså inte tillbaka poäng som förfallit sedan du transfererade dem.",
      },
      "2": {
        "Q": "Vem kan köpa EuroBonus Bonuspoäng?",
        "A": "För att kunna köpa, transferera eller ta emot Bonuspoäng måste personen ha varit medlem minst 1 år och det finns minst en aktvitet registrerad på EuroBonus-kontot. Du måste även ha minst 1000 poäng tillgängligt på ditt konto.",
      },
      "3": {
        "Q": "Kan jag nå en högre medlemsnivå om jag köper Bonuspoäng eller får Bonuspoäng transfererade till mitt konto?",
        "A": "Nej, Bonuspoäng kvalificerar inte till högre medlemsnivå. För att nå en högre medlemsnivå behöver du Nivåpoäng. Det är endast möjligt att köpa Nivåpoäng om du först tjänat ihop större delen av Nivåpoängen genom att flyga.",
      },
      "4": {
        "Q": "Hur många poäng kan en medlem få från en annan medlem per år?",
        "A": "Oavsett om det är köpta Bonuspoäng eller transfererade poäng så kan mottagaren få upp till 100 000 EuroBonus Bonuspoäng per år.",
      },
      "VIEW_MORE": "Visa fler frågor & svar",
    },
    "FIND_RECIPIENT": {
      "EB": "EuroBonus-nummer",
      "FIND_TRAVELER": "Sök",
      "LAST_NAME": "Efternamn",
      "SUCCESS": "Denna medlem kan få ytterligare %points detta år.",
    },
    "PAYMENT_BOX": {
      "TITLE": "Hur vill du betala transaktionskostaden?",
      "PAY_WITH_POINTS": "Betala med poäng (+%points poäng)",
      "PAY_WITH_CASH": "Kortbetalning (+%cash kr)",
      "SUMMARY": "Sammanfattning",
      "GIFTED_POINTS": "Antal poäng",
      "TRANSACTION_FEE": "Transaktionsavgift",
      "TO_PAY": "Att betala",
      "TRANSFER_POINTS": "Överför poäng",
    },
    "SUCCESS": {
      "TITLE": "Beställning genomförd",
      "ORDER_NUMBER": "Ordernummer",
      "ORDER_OVERVIEW": "Orderöversikt",
      "CONFIRMATION": "Bekräftelse",
      "CONFIRMATION_INFO": "Du har slutfört ett köp av EuroBonus-poäng till %member. Nedan följer detaljer om ditt köp. Du får bekräftelse till din e-postadress inom kort. Kontakta vår kundservice vid frågor om din beställning.",
      "INFORMATION": "Information",
      "INFORMATION_INFO": "EuroBonus-poäng överförs omgående till mottagaren. Om mottagaren inte mottagit poäng inom 24h, vänligen kontakta kundservice.",
      "CONTACT_US": "Kontakta oss",
      "CONTACT_US_INFO": "Har du en fråga om sortimentet eller om din beställning? Tveka inte att ta kontakt med oss!",
      "CUSTOMER_SERVICE": "Kundservice",
      "TRAVELER": "Medlem",
      "EUROBONUS_NUMBER": "EuroBonus-nummer",
      "LAST_NAME": "Efternamn",
      "ORDER_CONTENTS": "Orderinnehåll",
      "PRODUCT": "Produkt",
      "PAYMENT": "Betalning",
      "CASH": "Kortbetalning",
      "POINTS": "Poäng",
    },
    "STEPS": {
      "TRAVELER": "Mottagare",
      "PURCHASE_POINTS": "Antal",
      "CONFIRMATION": "Bekräftelse",
      "SUMMARY": "Summering",
      "PAYMENT": "Betalning",
    },
    "TIERS": {
      "EARNED_CURRENT": "Du har hittills tjänat %points under din nuvarande kvalificeringsperiod.",
      "EARNED_PREVIOUS": "Du tjänade %points under din föregående kvalificeringsperiod.",
      "EXTEND": "Köp till ytterligare %points för att förlänga",
      "UPGRADE": "Köp till ytterligare %points för att uppgradera till",
      "LEVEL": "som medlemsnivå.",
    },
    "BASIC_POINTS": {
      "HEADER": "Köp Nivåpoäng",
      "INFO": "Ditt konto uppfyller inte kraven för att köpa Nivåpoäng.",
      "LINK": "För mer information läs här.",
    },
  },
  "SORT": {
    "OFFCANVAS": {
      "TITLE": "Sortera",
      "SHOW_RESULT": "Visa resultat",
      "CLOSE_MENU": "Stäng sorteringsmenyn",
    },
  },
  "FILTER": {
    "FILTERBAR": {
      "ALL_FILTERS": "Filtrera",
      "FILTER_BY_POINTS": "Filtrera på poäng",
      "FILTER_BY_PRICE": "Filtrera på pris",
      "PRICE_RANGE_MIN": "%min poäng",
      "PRICE_RANGE_MAX": "%max poäng",
      "SORT": "Sortera",
      "SORT_DEFAULT": "Utvalda",
      "SORT_NAME_DOWN": "Produktnamn: Ö-A",
      "SORT_NAME_UP": "Produktnamn: A-Ö",
      "SORT_PRICE_DOWN": "Dyrast",
      "SORT_PRICE_UP": "Billigast",
      "SORT_POSITION_DOWN": "Populärast",
      "SORT_POPULAR_DOWN": "Populärast",
      "SORT_VALUE_DOWN": "Värde: Lågt",
      "SORT_VALUE_UP": "Värde: Högt",
      "SORT_RELEASE_DATE_DOWN": "Utgivningsdatum: Senaste",
      "SORT_RELEASE_DATE_UP": "Utgivningsdatum: Äldst",
      "SORT_LATEST_DOWN": "Senaste",
      "SORT_MANUFACTURER_DOWN": "Varumärke: Ö-A",
      "SORT_MANUFACTURER_UP": "Varumärke: A-Ö",
      "SORT_CREATED_AT_DOWN": "Senast tillagd: Senaste",
      "SORT_CREATED_AT_UP": "Senast tillagd: Äldst",
      "SORT_RELEVANCE_DOWN": "Mest relevant",
      "SORT_RELEVANCE_UP": "Minst relevant",
      "RANGESLIDER": "Skjutreglage",
    },
    "OFFCANVAS": {
      "TITLE": "Filter",
      "SHOW_RESULT_TOTAL_SINGLE": "%total Produkt",
      "SHOW_RESULT_TOTAL_MULTIPLE": "%total Produkter",
      "SHOW_RESULT": "Visa resultat",
      "CLOSE_MENU": "Stäng filtermenyn",
    },
    "ACTIVE_FILTERS": {
      "CLEAR_ALL": "Rensa filter",
      "NO_ACTIVE_FILTERS": "Du har inga aktiva filter",
      "PRICE_RANGE": "Pris (%range)",
      "TOTAL_COUNT": "Visar %count produkter",
      "REMOVE": "Ta bort filter",
    },
    "FILTERMENU": {
      "FILTER_BY_PRICE": "Filtrera på poäng",
      "FILTER_BY_POINTS": "Filtrera på poäng",
      "RESET_PRICE": "Rensa filter",
      "PRICE_FROM": "Från",
      "PRICE_TO": "Till",
      "BALANCE_FILTER": "Filtrera på saldo (%value poäng)",
      "WITHIN_BALANCE": "Produkter inom poängsaldo",
    },
  },
  "WISHLIST": {
    "TITLE": "Önskelista",
    "ADD_TO_WISHLIST": "Lägg till i önskelista",
    "REMOVE_FROM_WISHLIST": "Ta bort från önskelista",
    "EMPTY": "Du har inga produkter i din önskelista.",
    "EXPLORE_ASSORTMENT": "Utforska sortimentet",
  },
  "ADDRESS": {
    "FIRSTNAME": "Förnamn",
    "LASTNAME": "Efternamn",
    "STREET_1": "Gatuadress 1",
    "STREET_2": "Gatuadress 2 (frivilligt)",
    "POSTCODE": "Postnummer",
    "CITY": "Stad",
    "COUNTRY": "Land",
    "EMAIL": "E-mail",
    "TELEPHONE": "Telefon",
    "EDIT": "Ändra",
    "NOT_YOUR_COUNTRY": "Inte ditt land?",
  },
  "OR": "eller",
  "CART": {
    "EMPTY": "Varukorgen är tom",
    "CANT_AFFORD_TITLE": "För lågt poängsaldo",
    "CANT_AFFORD_INFO": "Du har inte tillräckligt med poäng för att lägga denna ordern.",
    "OF": "av",
    "NAV_BUTTON_OPEN": "Öppna varukorgen - %count produkt(er)",
    "NAV_BUTTON_CLOSE": "Stäng varukorgen - %count produkt(er)",
    "NAV_BUTTON_CART": "Gå till varukorgen - %count produkt(er)",
    "CTA": "Gå till kassan",
    "ALT": "Ändra i varukorg",
    "EDIT": "Ändra i varukorg",
    "TO_PAY": "Att betala",
    "INCREMENT": "Öka kvantitet",
    "DECREMENT": "Minska kvantitet",
    "QUANTITY": "Kvantitet",
    "CONTINUE_SHOPPING": "fortsätt handla",
    "SHIPPING": "Frakt",
    "SUBTOTAL": "Summa",
    "GRANDTOTAL": "Totalsumma",
    "YOUR_BALANCE": "Ditt poängsaldo",
    "SUMMARY": "Summering",
    "TO_CHECKOUT": "Gå till kassan",
    "TO_CHECKOUT_CANT_AFFORD": "Du har inte tillräckligt med poäng för att slutföra köpet.",
    "REMOVE_PRODUCT": "Ta bort produkt",
    "REMOVE_APPROVE": "Ja, ta bort",
    "CONFIRM_TEXT": "Vill du verkligen ta bort '%itemName' från varukorgen?",
    "YOULL_EARN": "Du kommer att tjäna %points",
    "MINIMIZE_SUMMARY": "Minimera översikt",
    "VIEW_DETAILS": "Visa detaljer",
    "PAY_ONLY_WITH_PTS": "Endast poäng",
    "ACCRUAL_TOOLTIP_TITLE": "Tjäna poäng",
    "ACCRUAL_TOOLTIP_DESCRIPTION": "När du köper vissa produkter tjänar du EuroBonus-poäng. Poängen sätts in på ditt konto 1 månad efter att köpet genomförts.",
    "CLOSE": "Stäng varukorgen",
    "CLOSE_SUMMARY": "Stäng summeringen",
    "OPEN_SUMMARY": "Öppna summeringen",
    "SUBMIT": "Spara antal",
  },
  "DIALOGUE": {
    "CANCEL": "Avbryt",
    "CLOSE": "Stäng dialog",
  },
  "NOTIFICATIONBAR": {
    "CLOSE": "Stäng banner",
  },
  "CHECKOUT": {
    "NEED_HELP": "Behöver du hjälp?",
    "CONTACT_CUSTOMER_SERVICE": "Kontakta kundtjänst",
    "TO_PAYMENT": "Gå till betalning",
    "CHOOSE_PAYMENT_METHOD": "Vidare till betalning",
    "POINTS_TITLE": "Hur många poäng vill du använda?",
    "POINTS_BALANCE": "Du har %points",
    "AMOUNT_TO_PAY": "Att betala",
    "TOOLTIP_TITLE": "Betala med poäng",
    "TOOLTIP_DESCRIPTION": "I SAS EuroBonus Shop kan du handla med poäng, pengar eller en kombination av båda. Genom att dra i reglaget väljer du enkelt hur många poäng du vill använda till ditt köp. Vill du använda alla dina poäng drar du reglaget helt till höger och vill du istället betala din order helt med pengar drar du reglaget längst till vänster.",
    "POINTS": "Poäng",
    "CASH": "Kortbetalning",
    "PAY_WITH_CARD": "Betala med kort",
    "CARD_PAYMENT": "Betala med kort",
    "EDIT": "Ändra",
    "PAYMENT_AND_DELIVERY": "Betalning & leverans",
    "DISTRIBUTION_POINTS": "EuroBonus-poäng",
    "DISTRIBUTION_CASH": "Kompletterande betalning med kort",
    "SENT_TO": "Skickas till",
    "CONFIRM_ORDER": "Slutför beställning",
    "CONTINUE_SHOPPING": "Fortsätt handla",
    "PAYMENT_TITLE": "Hur vill du betala?",
    "I_ACCEPT_THE": "Jag accepterar",
    "TERMS": "köpvillkoren",
    "ACCORDION_HEADER_CART": "Varukorg",
    "VIRTUAL_TERMS": "Jag samtycker till att det digitala presentkortet levereras omedelbart och är medveten om att detta innebär att jag inte längre har ångerrätt.",
    "ADDRESS": {
      "ADDRESS": "Adress",
      "SHIPPING": "Leveransadress",
      "BILLING": "Kvittoadress",
      "SHIP_TO_SAME_ADDRESS": "Samma adress på kvitto",
      "EMPTY_ADDRESS": "Adressen är inte komplett, vänligen uppdatera",
    },
    "STEPS": {
      "CART": {
        "SHORT": "Varukorg",
        "LONG": "Varukorg",
      },
      "SHIPPING": {
        "SHORT": "Leverans",
        "LONG": "Kontrollera din adress",
      },
      "PAYMENT": {
        "SHORT": "Fördela betalning",
        "LONG": "Fördela din betalning",
      },
      "OVERVIEW": {
        "SHORT": "Betala",
        "LONG": "Översikt",
      },
    },
  },
  "PAYMENT": {
    "USE_CARD": "Betala med kort",
    "USE_SAVED_CARD": "Betala med sparat kort",
  },
  "PAYMENT_METHODS": {
    "APPLE_PAY": "pay",
  },
  "CUSTOMER_SERVICE": {
    "TEXT": "Kundservice",
    "LINK": "/customer-service",
  },
  "SUCCESS": {
    "TITLE": "Beställning registrerad",
    "SUB_TITLE": "Ordernummer %number",
    "BACK": "Återgå till shoppen",
    "VALID_UNTIL": "Giltig t.o.m. %date",
    "WHAT_NOW": "Så vad händer nu?",
    "ORDER_OVERVIEW": "Orderöversikt",
    "NOT_FOUND_TITLE": "Ingen order hittades.",
    "NOT_FOUND_SUBTITLE": "Vänligen kontakta kundtjänst om detta är felaktigt.",
    "CONTACT": {
      "TITLE": "Kontakta oss",
      "CREATE_TICKET": "Skapa ärende",
      "INFO": "Du kan skapa ärende när som helst.</br>Under arbetstid svarar vi vanligtvis inom 1-2 timmar.",
      "OR": "eller",
      "REGRET_PURCHASE": "Ångra mitt köp",
      "CALL_US": "Ring oss",
      "CALL_US_HOURS": "Öppettider:<br />mån-fre: 09.00-12.00, lör-sön: Stängt",
      "CALL_US_PHONENUMBER": "+46 (0)31 700 83 86",
    },
    "STEPS": {
      "NORMAL": {
        "1": {
          "HEADING": "Bekräftelse",
          "TEXT": "En orderbekräftelse kommer att skickas till %email.",
        },
        "2": {
          "HEADING": "Bearbetning",
          "TEXT": "Din beställning skickas när samtliga produkter finns tillgängliga för leverans. Vanligen sker detta redan nästkommande dag.",
        },
        "3": {
          "HEADING": "Transport",
          "TEXT": "När dina varor packats och skickats så meddelas du via e‑post. I leveransbekräftelsen finner du en spårningslänk med vilken du kan följa paketets väg. Leveransen tar normalt 3-7 dagar.",
        },
        "4": {
          "HEADING": "Leverans",
          "TEXT": "Vissa paket levereras direkt till din brevlåda. Paket som är för stora levereras i stället till närmaste utlämningsställe och aviseras via sms till det mobilnummer du angivit i beställningen. Paketet ligger kvar på utlämningsstället i 14 dagar.",
        },
      },
      "MIXED": {
        "1": {
          "HEADING": "Bekräftelse",
          "TEXT": "En orderbekräftelse kommer att skickas till %email.",
        },
        "2": {
          "HEADING": "Bearbetning",
          "TEXT": "Din beställning skickas när samtliga produkter finns tillgängliga för leverans. Vanligen sker detta redan nästkommande dag. Din digitala produkt skickas inom kort.",
        },
        "3": {
          "HEADING": "Transport",
          "TEXT": "När dina varor packats och skickats så meddelas du via e‑post. I leveransbekräftelsen finner du en spårningslänk med vilken du kan följa paketets väg. Leveranstid tar normalt 3-7 dagar.",
        },
        "4": {
          "HEADING": "Leverans",
          "TEXT": "Vissa paket levereras direkt till din brevlåda. Paket som är för stora levereras i stället till närmaste utlämningsställe och aviseras via sms till det mobilnummer du angivit i beställningen. Paketet ligger kvar på utlämningsstället i 14 dagar. Din digitala beställning kommer att skickas till %email inom kort.",
        },
      },
      "VIRTUAL": {
        "1": {
          "HEADING": "Bekräftelse",
          "TEXT": "En orderbekräftelse kommer att skickas till %email.",
        },
        "2": {
          "HEADING": "Leverans",
          "TEXT": "Din digitala beställning kommer att skickas till %email inom kort.",
        },
      },
    },
  },
  "SERIAL_CODE": {
    "FETCH_STATUS": {
      "LOADING": "Vänta medan vi laddar din värdekod",
      "ERROR": "Ett fel har uppstått, din kod är skickad med e-post.",
    },
  },
  "OLD_BROWSER": {
    "INFO": "Hej! Du använder en utdaterad webbläsare. Vänligen <a href=\"http://outdatedbrowser.com\" rel=\"noopener\" target=\"blank\">uppdatera din webbläsare</a> för att använda saseurobonusshop.com",
  },
  "CATEGORY": {
    "PRODUCTS_IN_CATEGORY_TITLE_SINGULAR": "Visar 1 produkt i",
    "PRODUCTS_IN_CATEGORY_TITLE_PLURAL": "Visar %itemsCount produkter i",
    "PRODUCTS_IN_CATEGORY_TITLE_EMPTY": "Visar produkter i",
    "SEE_ALL_IN_MAIN_CATEGORY": "Se alla i %mainCategory",
  },
  "PRODUCTLIST": {
    "EMPTY": "Det finns inga produkter att visa just nu",
  },
  "POPULAR": {
    "POPULAR_PRODUCTS": "Populära produkter",
  },
  "404": {
    "TITLE": "Sidan kunde inte hittas",
    "HEADING": "— 404 —",
    "SUBHEADING": "Sidan kunde inte hittas",
  },
  "SERVER_ERROR": {
    "TITLE": "Serverfel",
    "HEADING": "Serverfel: 500",
    "SUBHEADING": "Vänligen återkom inom kort!",
    "TEXT": "<strong>Behöver du kontakta oss?</strong><br/> Skicka ett mail till <a href=\"mailto:kundservice@crossroads.se\">kundservice@crossroads.se</a>",
  },
  "SLIDER": {
    "SLIDE": "Slide %number",
  },
  "SEARCH": {
    "TITLE_PREFIX": "Sök: ",
    "PLACEHOLDER": "Sök i EuroBonus-sortimentet",
    "RESULTS": "Resultat för sökningen \"%query\"",
    "TYPE": {
      "CATEGORY": "Kategori",
      "PRODUCT": "Produkt",
      "BRAND": "Varumärke",
    },
    "OPEN": "Öppna sök",
    "CLOSE": "Stäng sökmenyn",
    "SEARCH_RESULT": "Hittade 1 produkt som matchade",
    "PRODUCTS_IN_SEARCH_RESULT": "Hittade %itemsCount produkter som matchade",
    "PRODUCT_IN_SEARCH_RESULT": "Hittade en produkt som matchade",
    "EMPTY": "Det finns inga produkter att visa just nu",
  },
  "ICONS": {
    "CHEVRON": "Pil",
    "CROSS": "Kryss",
    "SEARCH": "Förstoringsglas",
    "HAMBURGER": "Tre horisontella streck (hamburgarikon)",
    "HEADPHONES": "Headset med mikrofon",
    "CART": "Kundvagn",
    "FILTER": "Tre linjer med varsin cirkel i",
    "SORT": "Tre horisontella streck (sorteringsikon)",
    "CHECK": "Bock",
    "CHAT": "Pratbubbla",
    "PHONE": "Telefon",
    "INFO": "Cirkel med ett i inuti",
    "PLUS": "Plus tecken",
    "MINUS": "Minus tecken",
    "SWEDEN_FLAG": "Svensk flagga",
    "NORWAY_FLAG": "Norsk flagga",
    "DENMARK_FLAG": "Dansk flagga",
    "OTHER_FLAG": "Jordglob",
    "HEART_EMPTY": "Tomt hjärta",
    "HEART_FILLED": "Ifyllt hjärta",
    "AMEX": "Logga för Amex",
    "MASTERCARD": "Logga för Mastercard",
    "VISA": "Logga för Visa",
    "GOOGLE_PAY": "Logga för Google Pay",
    "MS_PAY": "Logga för Microsoft Wallet",
    "APPLE_PAY": "Logga för Apple Pay",
    "LINK": "Fyrkant med pil inuti (länkikon)",
    "HEADSUP": "Ifylld cirkel med utropstecken inuti",

  },
  "HEADER": {
    "SHOPNAME": "EuroBonus Shop",
    "NAVIGATION": "Navigation",
    "MAIN_NAVIGATION": "Huvudmeny",
    "SEARCH": "Sök",
    "CATEGORIES": "Kategorier",
    "BRANDS": "Varumärken",
    "CART": "Kassan",
    "LOGOUT": "Logga ut",
    "LOGIN": "Logga in",
    "DELIVER_TO": "Levereras till",
    "GO_TO_SAS": "Gå till sas.se",
    "MY_ACCOUNT": "Mitt konto",
    "GIFTCARDS": "Presentkort",
    "CLOSE": "Stäng",
    "OPEN_MENU": "Öppna menyn",
    "CLOSE_MENU": "Stäng menyn",
    "GO_BACK": "Gå tillbaka",
    "CONTACT": "Kontakta oss",
  },
  "DRAWER": {
    "OPEN_SUBMENU": "Öppna undermeny",
    "CLOSE_SUBMENU": "Stäng undermeny",
  },
  "FOOTER": {
    "LINKS": {
      "NAVIGATION": "Sidfotsmeny",
      "TERMS": {
        "TEXT": "Villkor",
        "LINK": "/terms",
      },
      "PRIVACY_POLICY": {
        "TEXT": "Integritetspolicy",
        "LINK": "/privacy-policy",
      },
      "ACCESSIBILITY": {
        "TEXT": "Tillgänglighet",
        "LINK": "/accessibility",
      },
    },
    "COPYRIGHT": "© %year Scandinavian Airlines System-Denmark-Norway-Sweden, org.nr 902001-7720, 195 87 Stockholm",
    "LEGAL": "SAS EuroBonus webbshop drivs av Awardit CLS AB. Copyright © %year Awardit CLS AB. All Rights Reserved.",
    "NEED_HELP": {
      "COOKIES": "Hantera cookies",
    },
  },
  "BREADCRUMBS": {
    "HOME": "Hem",
    "HOME_URL": "/",
    "SEARCH": "Sökresultat för \"%query\"",
    "ADVENT_CALENDAR": "Julkalender",
  },
  "PRODUCT": {
    "ADD_TO_CART": "Lägg i varukorg",
    "OUT_OF_STOCK": "Ej i lager",
    "RELATED_PRODUCTS": "Relaterade produkter",
    "CROSS_SELL_PRODUCTS": "Andra gillade också",
    "OPTION_DROPDOWN_PLACEHOLDER": "Välj ett val",
    "LOGIN_TO_PURCHASE": "Logga in för att kunna handla",
    "CHANGE_IMAGE": "Byt bild",
    "GO_TO_MANUFACTURER": "Se alla produkter från %brand",
    "ABOUT_BRAND": "Om %brand",
    "COLOR": "Färg:",
    "CHOOSE_A_COLOR": "Välj en färg",
    "POINTS_ONLY": "Endast poäng",
    "EARN": "Tjäna %points",
    "EARN_UP_TO": "Tjäna upp till %points",
    "PAY_AT_LEAST_PTS": "Du måste använda minst %points poäng vid köp av denna produkt. Resterande belopp betalas med kreditkort.",
    "PAY_ONLY_WITH_PTS": "Denna produkten kan endast betalas med poäng",
    "DESCRIPTION": "Produktbeskrivning",
    "EARNINGS": "Earnings from this purchase",
    "SHIPPING_TERMS": "Shipping terms",
    "ACCRUAL_TOOLTIP_TITLE": "Tjäna poäng",
    "ACCRUAL_TOOLTIP_DESCRIPTION": "När du köper denna produkt tjänar du EuroBonus-poäng. Poängen sätts in på ditt konto 1 månad efter att köpet genomförts.",
    "REDEMPTION_DISABLED": "Du kan inte köpa något från ditt konto just nu.",
    "EXPERIENCE_URL_BUTTON": "Till produkten",
    "EXTERNAL_EXPERIENCE": "SAS Experience",
    "EXTERNAL_EXPERIENCE_URL": "/experiences-by-eurobonus",
  },
  "MISSING_ADDRESS_TEXT": "Du måste skriva in din adress & kontaktuppgifter på <a target='_blank' href='https://www.sas.se/profile/settings/'>sas.se</a>",
  "MISSING_ADDRESS_TEXT_LONG": "Du måste skriva in din adress & kontaktuppgifter på <a target='_blank' href='https://www.sas.se/profile/settings/'>sas.se</a> för att kunna transferera Bonuspoäng, köpa Bonuspoäng eller Nivåpoäng.",
  "STRIPE": {
    "PROCESSING": "Laddar...",
    "CARD_NUMBER": "Kortnummer",
    "MM/YY": "MM/YY",
    "CVC": "CVC",
  },
  "OTP": {
    "TITLE": "Verifiera ditt EuroBonus-konto",
    "INFO": "En verifieringskod har skickats till telefonnumret som är registrerat på din EuroBonus-profil.",
    "FIELD_LABEL": "Kod",
    "SUBMIT": "Verifiera",
    "REQUEST_NEW_CODE_TITLE": "Har du inte fått någon kod?",
    "REQUEST_NEW_CODE": "Skicka ny kod",
    "CUSTOMER_SERVICE": "Kontakta kundservice",
  },
  "NEWSLETTER": {
    "SUCCESS_TITLE": "Verifiera din epostadress",
    "SUCCESS_BODY": "För att slutföra din registrering, vänligen kolla din e-post och verifiera din e-postadress genom att följa länken i det e-postmeddelande du har fått från oss.",
    "ERROR_TITLE": "Något har gått fel",
    "ERROR_BODY": "Vänligen försök att registrera dig igen.",
    "FINISHED_TITLE": "Tack för din anmälan",
  },
  "VALIDATION": {
    "REQUIRED": "Obligatoriskt fält",
    "EMAIL": "Vänligen fyll i en korrekt e‑postadress",
    "errorInvalidEmail": "Vänligen fyll i en korrekt e‑postadress",
    "errorEmailExists": "Emailadressen du angav används redan av ett annat konto",
    "PHONE": "Vänligen fyll i ett korrekt mobiltelefonnummer",
    "NUMERIC": "Fältet får bara innehålla nummer",
    "LENGTH_LT": "Fältet innehåller för många tecken",
    "POSTCODE": "Vänligen fyll i ett korrekt postnummer (XXX XX)",
    "NO_SHIPPING_GB": "Ej tillgängligt på grund av Brexit",
  },
  "STATUS_CODE": {
    /* Client */
    "UNKNOWN": "Ett okänt fel har uppstått. Vänligen ladda om sidan och försök igen.",
    "NETWORK_ERROR": "Anropet avbröts. Vänligen verifiera att du har en aktiv internetanslutning eller försök igen om en stund.",
    "PLACE_ORDER_CATCH": "Ett fel uppstod. Vänligen försök igen senare.",
    "AQUIRER_DECLINE": "Betalningen har nekats. Vänligen verifiera dina kort-/kontouppgifter.",

    "errorUnknownProduct": "Okänd produkt, vänligen försök igen.",

    "errorProductQuantityNotAvailable": "Det antal du angav finns inte tillgängligt just nu.",
    "errorProductNotInStock": "Produkten du försökte lägga i varukorgen finns dessvärre inte i lager just nu.",
    "errorProductMaxQuantity": "Det angivna antalet finns dessvärre inte i lager just nu.",
    "errorProductNotChosenVariant": "Vänligen välj %attributeLabel för att kunna lägga till produkten i din varukorg.",
    "termsNotAccepted": "Du måste godkänna köpvillkoren för att genomföra ditt köp.",

    "errorNotLoggedIn": "Du är inte inloggad, vänligen logga in.",
    "errorInvalidState": "Något gick fel, vänligen prova igen.",
    "errorInvalidLogin": "Felaktiga inloggningsuppgifter",
    "errorMissingCustomer": "Kunden du försöker logga in som finns inte",
    "errorInsufficientSasPointsForPurchase": "Kontots poängsaldo är för lågt",
    "errorBlacklistedEmail": "Emailadressen du angav används redan av ett annat konto. Vänligen ange en annan.",
    "errorEmailExists": "Emailadressen du angav används redan av ett annat konto. Vänligen ange en annan.",
    "errorInvalidEmailOrPassword": "Fel epostadress eller lösenord",

    "errorBillingAddressValidationFailed": "Ogiltig adress, försök igen",
    "errorShippingAddressValidationFailed": "Ogiltig adress, försök igen",
    "errorInvalidEmailAddress": "Ogiltiga kontaktuppgifter",
    "errorInvalidEmail": "Ogiltig emailadress",

    "errorNoItems": "Oväntat fel, försök igen",
    "errorNoShippingMethod": "Oväntat fel, försök igen",
    "errorProductsNotAvailable": "Oväntat fel, försök igen",

    "errorPaymentNotAvailable": "Betalningsfel",
    "errorInvalidPaymentMethod": "Betalningsfel",
    "errorNoPaymentMethod": "Betalningsfel",

    "errorFraudOrder": "Köpet är inte tillåtet. Kontakta support för mer information",
    "errorFraudProduct": "Gränsen har nåtts för en eller flera produkter i varukorgen. Kontakta support för mer information.",
    "errorFraudBlacklist": "Köpet är inte tillåtet. Kontakta support för mer information.",

    "Your card number is incomplete": "Vänligen fyll i dina kortuppgifter.",

    "YOUR_CARD_HAS_INSUFFICIENT_FUNDS": "Du saknar täckning på kortet.",
    "YOUR_CARDS_SECURITY_CODE_IS_INCORRECT": "CVC koden för kortet är inte korrekt.",
    "YOUR_CARD_WAS_DECLINED": "Kortet nekades.",
    "YOUR_CARD_HAS_EXPIRED": "Kortet är utgånget.",
    "AN_ERROR_OCCURRED_WHILE_PROCESSING_YOUR_CARD_TRY_AGAIN_IN_A_LITTLE_BIT": "Ett fel inträffade, försök igen om en liten stund.",
    "WE_ARE_UNABLE_TO_AUTHENTICATE_YOUR_PAYMENT_METHOD_PLEASE_CHOOSE_A_DIFFERENT_PAYMENT_METHOD_AND_TRY_AGAIN": "Vi kunde inte godkänna betalningsmetoden. Vänligen försök igen.",
    "INTERNAL_SERVER_ERROR": "Internt serverfel.",

    "CODE_COPIED": "Värdekoden kopierades till urklippet.",
    "CODE_NOT_COPIED": "Värdekoden kunde inte kopieras.",
    "WISHLIST_VARIANT": "Välj en konfiguration först",
    "errorPointRedemptionNotAllowed": "Köp med poäng är avstängt på ditt konto just nu.",
    "ITEM_REMOVED_FROM_CART": "%name togs bort från varukorgen eftersom att den inte längre finns i lager.",
    "NO_SHIPPING_GB": "På grund av Brexit och de nya reglerna kan vi för närvarande inte leverera till Storbritannien. Vi jobbar heltid med detta och hoppas på en lösning snart.",
    "errorGeneralError": "Tyvärr kunde vi ej skicka en verifieringskod till dig  - Vi ber dig prova att igen senare eller kontakta SAS kundtjänst.",

    // OTP
    "invalid_sso_token_or_otp": "Felaktig OTP. Vänligen försök igen",
    "invalid_sso_ticket": "Din session löpte ut. Vänligen logga in igen.",
    "NEW_OTP_SMS_SENT": "Ny kod skickades",
    "ERROR_VALIDATION": "Valideringsfel. Kontrollera att uppgifterna är korrekta och försök igen.",
    "ERROR_OTP_EMAIL": "Problem med emailtjänsten. Försök igen senare. Kontakta SAS support om problemet kvarstår.",
    "ERROR_OTP_SMS": "Problem med SMS-tjänsten. Försök igen senare. Kontakta SAS support om problemet kvarstår.",
    "ERROR_PROFILEDATA_LOOKUP": "Kunde inte hitta profildata. Försök igen senare.",
    "SERVICE_UNAVAILABLE": "Tjänsten är för närvarande inte tillgänglig. Försök igen senare.",
    "ERROR_REGION_PHONE": "Kan inte nå regionens telefonnummer. Försök igen senare.",
    "ERROR_TIMEOUT": "Timeout. Vänta och försök igen senare.",
    "ERROR_MAX_ATTEMPTS_REACHED": "För många anrop. Vänligen vänta några minuter och prova igen.",

    "ADVENT_CALENDAR": {
      "notModified": "E-postadressen är redan registrerad",
      "invalidEmail": "Ogiltig E-postadress",
      "success": "Du är nu registrerad",
    },

    "TRANSFER_POINTS": {
      "errorNotFound": "Vi kunde inte hitta en användare med det EuroBonus-numret.",
      "errorTooManySuccess": "För många sökförsök. Vänligen vänta en stund och försök sedan igen.",
      "noSuccess": "Ett okänt fel har uppstått. Vänligen ladda om sidan och försök igen.",
      "errorCannotTransferTo": "Det går inte att överföra poäng till denna mottagaren.",
      "errorPointRedemptionNotAllowed": "Du befinner dig för närvarande inte i en kvalificeringsperiod där poängen kommer att räknas mot din bonusnivå.",
      "errorCannotBuyForSelf": "Ditt konto uppfyller inte kraven för att köpa poäng till dig själv.",
      "errorCannotBuyForOther": "Ditt konto uppfyller inte kraven för att köpa eller överföra poäng till någon annans konto.",
    },
  },
};
